/**
 * Tags that get applied to players after fetching data from Shopify.
 */
export default interface Tags {
  item_count: number;
  item_name?: string;
  item_image_url?: string;
  customer_id?: string;
}

/**
 * Util method to determine if the tags objects are equal.
 * 
 * If either of the objects are undefined, then it will always return false.  Even if both values are undefined.
 * This then will go through and compare each of the keys on both objects.
 * 
 * @param a Tags object to compare against.
 * @param b Tags object to compare against.
 */
export function areTagsEqual(a?: Tags, b?: Tags): boolean {
  if (!a || !b) {
    return false;
  }

  const keys = Object.keys(a) as (keyof Tags)[];
  for (const key of keys) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}
